import { PopupReturnTypeWithPayload } from '../../../hooks/usePopup'
import { initialPopup } from '../../../hooks/constants'
import { DeleteResponseUserPayload } from '../ContractDetailsGeneral/ResponsibleUsers/DeleteUserPopup/types'
import { TResponsibleUser } from '../../RFP/RFPDetails/types'
import {
  IRenewFinishDatePayload,
  TPreviewDocument
} from '../ExtendContract/types'
import { Moment } from 'moment/moment'
import { IContractHealthSystem } from '../Facilities/types'
import { ManualContractCreationRequestData } from '../types'
import { TUploadAutoContractDocumentsPayload } from '../ContractDetailsGeneral/ContractDetailsDocuments/UploadMultipleContractDocumentsPopup/types'

export const deleteResponsibleUserPopupWithPayload: PopupReturnTypeWithPayload<DeleteResponseUserPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: { user: {} as TResponsibleUser }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }

export const renewFinishDatePopupWithPayload: PopupReturnTypeWithPayload<IRenewFinishDatePayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        newFinishDate: {} as Moment,
        extensionDocument: {} as TPreviewDocument
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }

export const addAmendmentPopupWithPayload: PopupReturnTypeWithPayload<{
  selectedHSRow: IContractHealthSystem
}> = {
  state: {
    ...initialPopup?.state,
    payload: {
      selectedHSRow: {} as IContractHealthSystem
    }
  },
  actions: {
    ...initialPopup.actions,
    setState: () => undefined
  }
}

export const assignResponsiblePopupWithPayload: PopupReturnTypeWithPayload<{
  creationDetails: Partial<ManualContractCreationRequestData>
}> = {
  state: {
    ...initialPopup?.state,
    payload: {
      creationDetails: {} as Partial<ManualContractCreationRequestData>
    }
  },
  actions: {
    ...initialPopup.actions,
    setState: () => undefined
  }
}

export const uploadAutoContractDocumentPopupWithPayload: PopupReturnTypeWithPayload<TUploadAutoContractDocumentsPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        uploadedDocumentsCount: 0
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }

export const acceptContractDocumentPopupWithPayload: PopupReturnTypeWithPayload<{
  documentId: string
}> = {
  state: {
    ...initialPopup?.state,
    payload: {
      documentId: ''
    }
  },
  actions: {
    ...initialPopup.actions,
    setState: () => undefined
  }
}

export const addSignatoryPopupWithPayload: PopupReturnTypeWithPayload<{
  documentId: string
}> = {
  state: {
    ...initialPopup?.state,
    payload: {
      documentId: ''
    }
  },
  actions: {
    ...initialPopup.actions,
    setState: () => undefined
  }
}
